import styled from "styled-components";

const SectionLabel = styled.p`
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.13em;
  color: var(--section-label-color, var(--accent));
  font-weight: 800;
  margin: 0 0 38px;
`;

export default SectionLabel;
